document.addEventListener('DOMContentLoaded', function() {
    var existingModals = document.querySelectorAll('.lot-lookup-modal');

    for (var modalIndex = 1; modalIndex < existingModals.length; modalIndex += 1) {
        existingModals[modalIndex].remove();
    }

    if (window.__lotLookupModalInitialized) {
        return;
    }

    if (existingModals.length) {
        window.__lotLookupModalInitialized = true;
        return;
    }

    var targetNode = document.querySelector('body');

    if (targetNode) {
        var callback = function(mutationList) {
            mutationList.forEach(function(mutation) {
                var localeSelector = mutation.target.querySelector('.locale-selectors__container');

                if (localeSelector && localeSelector.parentElement) {
                    localeSelector.parentElement.remove();
                }
            });
        };

        new MutationObserver(callback).observe(targetNode, { childList: true, subtree: true });
    }

    var lookupButtons = document.querySelectorAll('.do-lot-lookup');

    if (!lookupButtons.length) {
        return;
    }

    window.__lotLookupModalInitialized = true;

    var modal = document.createElement('div');
    modal.className = 'lot-lookup-modal';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = [
        '<div class="lot-lookup-modal__overlay" data-lot-lookup-close></div>',
        '<div class="lot-lookup-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="lot-lookup-modal-title">',
            '<button class="lot-lookup-modal__close" type="button" aria-label="Close" data-lot-lookup-close>&times;</button>',
            '<div class="lot-lookup-modal__content">',
                '<span class="lot-coa-information__eyebrow fs-body-50">Lot Information</span>',
                '<p class="lot-coa-information__heading ff-heading fs-heading-5-base" id="lot-lookup-modal-title">Results</p>',
                '<p class="lot-lookup-modal__error" role="alert" hidden></p>',
                '<div class="lot-lookup-modal__details" hidden></div>',
                '<div class="lot-lookup-modal__file" hidden>',
                    '<span class="lot-coa-information__eyebrow fs-body-50">Certificate of Analysis</span>',
                    '<a class="lot-coa-information__link btn btn--secondary btn--small" target="_blank" rel="noopener"></a>',
                '</div>',
            '</div>',
        '</div>'
    ].join('');
    document.body.appendChild(modal);

    var details = modal.querySelector('.lot-lookup-modal__details');
    var error = modal.querySelector('.lot-lookup-modal__error');
    var file = modal.querySelector('.lot-lookup-modal__file');
    var fileLink = file.querySelector('a');
    var lotLookupBaseUrl = 'https://api.itlhealth.com/gs/lot-data/';

    function closeModal() {
        document.querySelectorAll('.lot-lookup-modal').forEach(function(modalInstance) {
            modalInstance.setAttribute('aria-hidden', 'true');
            modalInstance.style.display = 'none';
        });
        document.body.classList.remove('lot-lookup-modal-open');
    }

    function openModal() {
        document.querySelectorAll('.lot-lookup-modal').forEach(function(modalInstance) {
            if (modalInstance !== modal) {
                modalInstance.remove();
            }
        });

        if (!document.body.contains(modal)) {
            document.body.appendChild(modal);
        }

        modal.setAttribute('aria-hidden', 'false');
        modal.style.removeProperty('display');
        document.body.classList.add('lot-lookup-modal-open');
        modal.querySelector('.lot-lookup-modal__close').focus();
    }

    function renderResult(data) {
        details.textContent = '';

        [
            ['Lot', data.lot],
            ['Use by date', data.use_date]
        ].forEach(function(item) {
            if (item[1] === undefined || item[1] === null || item[1] === '') {
                return;
            }

            var row = document.createElement('p');
            var label = document.createElement('span');
            row.className = 'lot-lookup-modal__item';
            label.className = 'lot-coa-information__label';
            label.textContent = item[0] + ':';
            row.appendChild(label);
            row.appendChild(document.createTextNode(' ' + String(item[1])));
            details.appendChild(row);
        });

        details.hidden = false;
        error.hidden = true;
        file.hidden = true;

        if (data.location) {
            fileLink.textContent = data.filename || 'View certificate';
            fileLink.href = new URL(data.location, lotLookupBaseUrl).href;
            file.hidden = false;
        }
    }

    function renderError(message) {
        details.textContent = '';
        details.hidden = true;
        file.hidden = true;
        fileLink.textContent = '';
        fileLink.removeAttribute('href');
        error.textContent = message || 'Lot lookup failed.';
        error.hidden = false;
    }

    function lookupLot(button) {
        var fieldset = button.closest('.lot-lookup-fieldset');
        var input = fieldset ? fieldset.querySelector('.lot-lookup') : document.querySelector('.lot-lookup');
        var lotNumber = input && input.value.trim();

        if (!lotNumber) {
            button.classList.add('error');
            return;
        }

        window.__lotLookupRequests = window.__lotLookupRequests || {};

        if (window.__lotLookupRequests[lotNumber]) {
            return;
        }

        window.__lotLookupRequests[lotNumber] = true;

        button.classList.remove('error');
        details.hidden = true;
        file.hidden = true;
        error.textContent = 'Looking up lot...';
        error.hidden = false;
        openModal();

        fetch(lotLookupBaseUrl + encodeURIComponent(lotNumber), { headers: { Accept: 'application/json' } })
            .then(function(response) {
                if (!response.ok) {
                    throw new Error('Lookup request failed.');
                }

                return response.json();
            })
            .then(function(data) {
                delete window.__lotLookupRequests[lotNumber];

                if (!data || data.success === false || data.error) {
                    renderError(data && data.error ? data.error : 'Lot not found.');
                    return;
                }

                input.value = '';
                renderResult(data);
            })
            .catch(function() {
                delete window.__lotLookupRequests[lotNumber];
                renderError('Unable to look up this lot. Please try again.');
            });
    }

    modal.addEventListener('click', function(event) {
        if (event.target.hasAttribute('data-lot-lookup-close')) {
            closeModal();
        }
    });

    document.addEventListener('click', function(event) {
        if (event.target.closest('[data-lot-lookup-close]')) {
            closeModal();
        }
    });

    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
            closeModal();
        }
    });

    lookupButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            lookupLot(button);
        });

        var fieldset = button.closest('.lot-lookup-fieldset');

        if (fieldset) {
            fieldset.addEventListener('keydown', function(event) {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    lookupLot(button);
                }
            });
        }
    });
});